function initSharedGallery(root){
 const slides=[...root.querySelectorAll('[data-zp-slide]')],thumbs=[...root.querySelectorAll('[data-zp-thumb]')],dialog=root.querySelector('.zp-dialog'),full=root.querySelector('[data-zp-full]'),stage=root.querySelector('[data-zp-swipe]');
 if(!slides.length||!dialog||!full||!stage)return;
 let active=0,lastSwipe=-1000;
 const count=()=>String(active+1).padStart(2,'0')+' / '+String(slides.length).padStart(2,'0');
 const updateFull=()=>{const photo=slides[active].querySelector('img');full.src=slides[active].querySelector('[data-zp-zoom]').dataset.zpFullSrc||photo.currentSrc||photo.src;full.alt=photo.alt;root.querySelector('[data-zp-full-count]').textContent=count();};
 const select=index=>{
  active=(index+slides.length)%slides.length;
  slides.forEach((slide,i)=>{slide.hidden=i!==active;});
  thumbs.forEach((thumb,i)=>thumb.setAttribute('aria-pressed',String(i===active)));
  root.querySelector('[data-zp-gallery-count]').textContent=count();
  const thumb=thumbs[active],strip=thumb?.parentElement;
  if(thumb&&strip)strip.scrollTo({left:thumb.offsetLeft-strip.offsetLeft-(strip.clientWidth-thumb.clientWidth)/2,behavior:'auto'});
  if(dialog.open)updateFull();
 };
 const step=delta=>select(active+delta);
 thumbs.forEach((button,index)=>button.addEventListener('click',()=>select(index)));
 root.querySelectorAll('[data-zp-step],[data-zp-full-step]').forEach(button=>{button.hidden=slides.length<2;button.addEventListener('click',()=>step(Number(button.dataset.zpStep||button.dataset.zpFullStep)));});
 const keys=event=>{if(event.key==='ArrowLeft'||event.key==='ArrowRight'){event.preventDefault();step(event.key==='ArrowLeft'?-1:1);}};
 stage.addEventListener('keydown',keys);dialog.addEventListener('keydown',keys);
 root.querySelectorAll('[data-zp-zoom]').forEach((button,index)=>button.addEventListener('click',()=>{if(performance.now()-lastSwipe<400)return;select(index);updateFull();dialog.showModal();}));
 const swipe=area=>{let start=null;
  area.addEventListener('pointerdown',event=>{if(event.isPrimary&&event.button===0)start={x:event.clientX,y:event.clientY};});
  area.addEventListener('pointercancel',()=>{start=null;});
  area.addEventListener('pointerup',event=>{if(!start)return;const dx=event.clientX-start.x,dy=event.clientY-start.y;start=null;if(Math.abs(dx)>45&&Math.abs(dx)>Math.abs(dy)*1.3){lastSwipe=performance.now();step(dx<0?1:-1);}});
  area.addEventListener('dragstart',event=>event.preventDefault());
 };
 swipe(stage);swipe(root.querySelector('[data-zp-full-swipe]'));
 root.querySelector('[data-zp-close]').addEventListener('click',()=>dialog.close());
 select(0);
}


const mediaControllers=new WeakMap();
function initProductVideo(video){
 if(mediaControllers.has(video))return;
 const events=new AbortController(),reduce=matchMedia('(prefers-reduced-motion: reduce)'),frame=video.closest('.rc-auto-video-frame');
 let visible=false;
 video.muted=true;video.playsInline=true;video.loop=true;
 const fit=()=>{if(frame&&video.videoWidth&&video.videoHeight)frame.style.setProperty('--rc-video-ratio',video.videoWidth/video.videoHeight);};
 const sync=()=>{if(visible&&!document.hidden&&!reduce.matches){const pending=video.play();pending?.catch(()=>{});}else video.pause();};
 const observer=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting&&entries[0].intersectionRatio>=.35;sync();},{threshold:[0,.35]});
 video.pause();observer.observe(video);fit();
 video.addEventListener('loadedmetadata',fit,{signal:events.signal});
 document.addEventListener('visibilitychange',sync,{signal:events.signal});
 reduce.addEventListener('change',sync,{signal:events.signal});
 mediaControllers.set(video,()=>{observer.disconnect();events.abort();video.pause();mediaControllers.delete(video);});
}
function initProductMedia(scope=document){
 scope.querySelectorAll('[data-rc-zero-gallery]').forEach(root=>{if(root.dataset.rcGalleryReady)return;root.dataset.rcGalleryReady='true';initSharedGallery(root);});
 if('IntersectionObserver'in window)scope.querySelectorAll('.rc-auto-video-frame video,.product-media video').forEach(initProductVideo);
}
initProductMedia();
document.addEventListener('shopify:section:load',event=>initProductMedia(event.target));
document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('video').forEach(video=>mediaControllers.get(video)?.()));
